module.exports = __webpack_public_path__ + "img/水印logo--实时渲染.e1c00247.png";